import { render, staticRenderFns } from "./LeaveSettings.vue?vue&type=template&id=707fcc98"
import script from "./LeaveSettings.vue?vue&type=script&lang=js"
export * from "./LeaveSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports